export default __webpack_public_path__ + "static/media/kaison.f0d9a1d4.png";